var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{isolation:isolate}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#2691d0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.89 15.42a.29.29 0 0 1-.09.21l-3 3 1.29 1.29a.56.56 0 0 1 .17.4.54.54 0 0 1-.17.4.54.54 0 0 1-.4.17h-4a.58.58 0 0 1-.58-.57v-4a.56.56 0 0 1 .17-.4.57.57 0 0 1 .81 0l1.28 1.29 3-3a.28.28 0 0 1 .2-.09.29.29 0 0 1 .21.09l1 1a.28.28 0 0 1 .11.21zm7-7.71v4a.58.58 0 0 1-.57.57.54.54 0 0 1-.4-.17l-1.29-1.28-3 3a.29.29 0 0 1-.42 0l-1-1a.28.28 0 0 1-.09-.2.29.29 0 0 1 .09-.21l3-3-1.32-1.31a.56.56 0 0 1 0-.8.51.51 0 0 1 .4-.17h4a.52.52 0 0 1 .4.17.56.56 0 0 1 .17.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.67ed23ef8457f01006b36a00031f7755.svg";
export { ForwardRef as ReactComponent };